import React from "react";
import { Box, Flex, FlexProps, useColorModeValue } from "@chakra-ui/react";
import { ReactComponent as Logo } from "@apollo/brand/logos/logotype.svg";

type TaggedLogoProps = {
  tag?: string;
  isSmall?: boolean;
} & FlexProps;

export const TaggedLogo: React.FC<TaggedLogoProps> = ({
  tag = "Odyssey",
  isSmall,
  ...props
}) => {
  const bgColor = useColorModeValue("blue.100", "whiteAlpha.200");
  const textColor = useColorModeValue("indigo.500", "inherit");
  return (
    <Flex direction="row" align="center" {...props}>
      <Box
        as={Logo}
        h={isSmall ? 6 : 8}
        fill="current"
        role="img"
        aria-label="Apollo logo"
      />
      <Box
        ml="2"
        borderRadius={isSmall ? 4 : "md"}
        px={isSmall ? 1 : 2}
        fontSize={isSmall ? "sm" : "lg"}
        lineHeight="short"
        fontWeight="semibold"
        textTransform="uppercase"
        letterSpacing="widest"
        bgColor={bgColor}
        color={textColor}
      >
        {tag}
      </Box>
    </Flex>
  );
};
